<script setup lang="ts">
interface DisclaimerProps {
  title?: string
  description?: string
}

const props = withDefaults(defineProps<DisclaimerProps>(), {
  title: '',
  description: ''
})
</script>

<template>
  <div class="flex items-center space-x-3 rounded-lg border-l-4 border-yellow-400 bg-yellow-50 p-4">
    <div class="flex-shrink-0">
      <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <div>
      <p class="font-medium text-yellow-800">
        <span class="font-semibold">{{ props.title }}</span
        ><br />
        {{ props.description }}
      </p>
    </div>
  </div>
</template>
